import { api } from "../../api/api";
import {
  getFileExtensionType,
  IFileExtension,
} from "../../components/FileUploadIcon/helpers";
import { IQueryParams } from "./common.types";

export const getSearchQuery = (queryParams: IQueryParams): string => {
  const {
    page,
    rowsPerPage,
    status,
    value,
    columns,
    fromDate,
    toDate,
    company_outlet_uuid,
  } = queryParams;
  let query = "?";
  if (status !== "-1") {
    query += `status=${status}&`;
  }
  if (columns.length > 0 && value.length > 0) {
    query += `columns=${columns}&`;
  }
  if (columns.length > 0 && value.length > 0) {
    query += `value=${value}&`;
  }
  if (fromDate) {
    query += `from_date=${fromDate}&`;
  }
  if (toDate) {
    query += `to_date=${toDate}&`;
  }
  query += `pageNo=${page}&itemPerPage=${rowsPerPage}`;
  return query;
};

export const getBase64Extension = (extension: string): string => {
  const fileType = getFileExtensionType(extension);
  if (fileType === "IMAGE") return `data:image/${extension};base64`;
  if (fileType === "EXCEL")
    return `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64`;
  return `data:application/${extension};base64`;
};

const arrayBufferToBase64V2 = (buffer: any, extension: string): string => {
  return `${getBase64Extension(extension)},${btoa(
    new Uint8Array(buffer).reduce(function (data, byte) {
      return data + String.fromCharCode(byte);
    }, ""),
  )}`;
};

export const downloadSingleFileAsync = async (fileUrl: string) =>
  new Promise<{ fileName: string; data: string; type: IFileExtension }>(
    (resolve, reject) => {
      const payload = {
        type: "json",
        keys: [fileUrl],
      };
      api
        .post("/general/download-files", payload)
        .then((res) => {
          const fileName = fileUrl?.split("/")[fileUrl?.split("/").length - 1];
          const fileExtension = fileName.split(".")[1];
          const base64Data = arrayBufferToBase64V2(
            res.data[0]?.data,
            fileExtension,
          );
          resolve({
            fileName: fileName,
            data: base64Data,
            type: getFileExtensionType(fileUrl),
          });
        })
        .catch((err) => {
          reject(err);
        });
    },
  );

export const downloadSingleImageAsync = async (
  fileUrl: string,
  abortSignal?: AbortSignal,
) => {
  const payload = {
    type: "json",
    keys: [fileUrl],
  };

  try {
    const res = await api.post("/general/download-files", payload, {
      signal: abortSignal,
    });
    const fileName = fileUrl?.split("/")[fileUrl?.split("/").length - 1];
    const fileExtension = fileName.split(".")[1];
    const base64Data = arrayBufferToBase64V2(res.data[0]?.data, fileExtension);

    return {
      fileName: fileName,
      data: base64Data,
      type: getFileExtensionType(fileUrl) as IFileExtension,
    };
  } catch (err: any) {
    if (err.name === "AbortError") {
      console.log("Fetch aborted");
    } else {
      throw err;
    }
  }
};
